import { createFileRoute } from '@tanstack/react-router';

import { AccountPage, sessionsQueryOptions } from '@/features/account';

/** Everyone manages their own account; no permission gate. */
export const Route = createFileRoute('/_authed/_active/account/')({
  staticData: { crumb: 'common:nav.account', tours: ['account.profile'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...sessionsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: AccountPage,
});
